// extracted by mini-css-extract-plugin
module.exports = {"icons":"contractulAccountSimplified_icons__BNX3S"};